<template>
  <div class="chat-message-container chat__log chat-content-scroll-area vs-con-loading__container" ref="internalChatContainer" id="infinite-list">
    <div class="internal-chat-no-message mt-5 ">
      <vs-chip v-if="(!existsOldMessages && dataLength >= 1) || !dataLength" color="black">
        <span class="text-white">Não existem mensagens anteriores</span>
      </vs-chip>
      <div
          id="show-loading-last-message"
          class="vs-con-loading__container"
          style="height: 100px !important; width: 100px !important; position: absolute; margin-top: 30px"
      ></div>
    </div>

    <div v-if="chatData !== undefined && chatData.length > 0" id="component-internal-chat-log">
      <div class="m-8">
        <div v-for="(chat, index) in chatData" :key="internalChatId(chat, index)" class="msg-grp-container">
          <div>
            <template v-if="chatData[index-1]">
              <vs-divider v-if="printDateLine(chat, chatData[index-1])" class="msg-time">
                <span v-if="chat.parentInternalChatMessage">
                  {{ toDate(chat.parentInternalChatMessage.created_at) }}
                </span>
                <span v-else>{{ toDate(chat.created_at) }}</span>
              </vs-divider>
              <div
                class="spacer mt-8"
                v-if="!hasSentPreviousMsg(chatData[index-1].type,chat.type)"
              ></div>
            </template>

            <div v-if="chat && chat.parentInternalChatMessage && chat.parentInternalChatMessage.id">
              <internal-chat-log-item
                :index="index"
                :hiddenReply="true"
                :type="renderChild(chat)"
                :chat="chat.parentInternalChatMessage"
              >
                <internal-chat-log-item
                    :chat="chat"
                    :index="index"
                    :type="renderChild(chat)"
                    :principalIndex="chat.parentInternalChatMessage.id"
                />
              </internal-chat-log-item>
            </div>
            <div v-else>
              <internal-chat-log-item
                  :chat="chat"
                  :index="index"
                  :type="renderChild(chat)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import InternalChatLogItem from "./InternalChatLogItem.vue";

export default {
  components: {InternalChatLogItem},
  props: {
    upInternalChat: {
      type: Boolean,
      required: true
    },
    activeChatUser: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    }
  },
  data() {
    return {
      limit: 10,
      offset: 10,
      apiPage: 1,
      apiLimit: 15,
      oldHeight: 1,
      makeScroll: false,
      existsOldMessages: true,
      showLoadingMessages: false,
      selectedLastDate: moment(new Date()).format('YYYY-MM-DD'),
    }
  },
  watch: {
    showLoadingMessages: {
      handler(value) {
        if (value) {
          this.$vs.loading({
            scale: 0.45,
            color: "primary",
            container: '#show-loading-last-message'
          })
        } else {
          this.$vs.loading.close('#show-loading-last-message > .con-vs-loading')
        }
      }
    }
  },
  computed: {
    chatData() {
      return this.$store.getters["internalChatMessages/selectedInternalChats"];
    },
    dataLength() {
      return this.chatData.length
    },
    activeUser() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    loadMore() {
      this.makeScroll = true;
      this.limit = this.limit + this.offset
      if (this.dataLength !== 0 && this.dataLength >= (this.apiLimit - 10)) {
        this.apiPage += 1;
      }
      this.observerChatData(true);
    },
    async observerChatData(concatResults = false) {
      this.showLoadingMessages = true;

      if (!concatResults){
        await this.$store.dispatch('internalChatMessages/resetInternalChatMessage');
      }

      await this.$store.dispatch('internalChatMessages/fetch', {
        userId: this.activeChatUser.id,
        userSendingId: this.activeUser.id,
        paginationPage: this.apiPage,
        paginationLimit: this.apiLimit,
        concatResults: concatResults
      }).then(()=>{
        this.existsOldMessages = (this.limit - this.dataLength) <= this.apiLimit;
        this.showLoadingMessages = false;

        if (this.limit > 10 && this.makeScroll) {
          this.makeScroll = false;
          this.setScroll()
        }
      }).catch((error) => {
        console.error(error);
        this.showLoadingMessages = false;
      })
    },
    printDateLine(chat, previousChat) {
      let showDate = !this.isSameDay(chat.created_at, previousChat.created_at)
      if (chat.parentInternalChatMessage && chat.parentInternalChatMessage.length > 0) {
        showDate = !this.isSameDay(chat.parentInternalChatMessage.created_at, previousChat.created_at)
      }
      return showDate
    },
    hasSentPreviousMsg(last_sender, current_sender) {
      return last_sender === current_sender
    },
    internalChatId(chat, index) {
      let cId = `chat-${chat.id}-${index}`
      if (chat.parentInternalChatMessage) { cId += '-' + chat.parentInternalChatMessage.id}
      return cId
    },
    toDate(time) {
      const locale = "pt-br";
      const date_obj = new Date(time.replace(/\s/, 'T'));
      const monthName = date_obj.toLocaleString(locale, {month: 'short'});
      return date_obj.getDate() + ' ' + monthName;
    },
    isSameDay(time_to, time_from) {
      if (time_to === undefined && time_from === undefined) {
        return null;
      }
      const date_time_to = new Date(time_to.replace(/\s/, 'T'))
      const date_time_from = new Date(time_from.replace(/\s/, 'T'));
      return date_time_to.getFullYear() === date_time_from.getFullYear() &&
          date_time_to.getMonth() === date_time_from.getMonth() &&
          date_time_to.getDate() === date_time_from.getDate();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.internalChatContainer.scrollTop = this.$refs.internalChatContainer.scrollHeight
      });
    },
    setScroll() {
      setTimeout(() => {
        if (this.$refs.internalChatContainer !== undefined) {
          this.$refs.internalChatContainer.scrollTop = this.$refs.internalChatContainer.scrollHeight - this.oldHeight;
          this.oldHeight = this.$refs.internalChatContainer.scrollHeight;
        }
      }, 1)
    },
    addListener() {
      const listElm = document.querySelector("#infinite-list");
      listElm.addEventListener("scroll", () => {
        if (listElm.scrollTop === 0 && this.existsOldMessages) {
          if (this.oldHeight !== 0) {
            this.loadMore();
          }
          this.oldHeight = listElm.scrollHeight
        }
      });
    },
    renderChild(chat) {
      let type = 'customer';

      if (chat.type === 0 && chat.parentInternalChatMessage && chat.parentInternalChatMessage.type === 0) {
        type = 'agent-agent'
      }

      if (chat.type === 1 && chat.parentInternalChatMessage && chat.parentInternalChatMessage.type === 1) {
        type = 'customer-customer'
      }

      if (chat.type === 1 && chat.parentInternalChatMessage && chat.parentInternalChatMessage.type === 0) {
        type = 'agent-customer'
      }

      if (chat.type === 0 && chat.parentInternalChatMessage && chat.parentInternalChatMessage.type === 1) {
        type = 'customer-agent'
      }

      return type;
    }
  },
  updated() {
    this.scrollToBottom();
  },
  mounted() {
    this.addListener();
    this.scrollToBottom();
    this.observerChatData()
  }
}
</script>

<style lang="scss">
#internal-chat-main {
  .chat-content-area .chat-content-scroll-area {
    overflow: auto;
  }
}
</style>